<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <span>{{$t('printTitle')}}</span>
            </template>
        </navbar>


        <b-row>
            <b-col>
                <b-card>
                    <b-card-header>
                        <b-button-group>
                            <b-button @click="changePaymentType('Bankomat bezahlt!')" variant="primary">Bankomat
                                bezahlt!
                            </b-button>
                            <b-button @click="changePaymentType('Bar bezahlt!')" variant="primary">Bar bezahlt!
                            </b-button>
                            <b-button @click="print" variant="danger">{{$t('printTitle')}}</b-button>
                        </b-button-group>
                    </b-card-header>

                    <b-card-body>
                        <div id="printMe" class="es-wrapper-color">

                            <div class="row">
                                <div class="col-6">
                                    <p class="mb-0">Lord of Hanf e.U.</p>
                                    <p class="mb-0">Kramergass 3/15</p>
                                    <p class="mb-0">A-1010 Wien</p>
                                    <p class="mb-0">T.: +43 (0)676/ 66 11 288</p>
                                    <p class="mb-0">Mail: <a
                                            href="mailto:office@lordofhanf.com">office@lordofhanf.com</a>
                                    </p>
                                    <p>Web: <a href="https://lordofhanf.com">www.lordofhanf.com</a></p>


                                    <div class="mt-4">

                                        <template v-if="order.order_is_anonymous === 'no' && orderDeliveryAddress !== null">
                                            <p class="mb-0">{{orderDeliveryAddress.first_name}}
                                                {{orderDeliveryAddress.last_name}}</p>
                                            <p class="mb-0">{{orderDeliveryAddress.address}}
                                                {{orderDeliveryAddress.address_more}}</p>
                                            <p class="mb-0">{{orderDeliveryAddress.post_code}}
                                                {{orderDeliveryAddress.town}}</p>
                                        </template>



                                        <template v-if="order.order_is_anonymous === 'no'">
                                            <template
                                                    v-if="order.order_type_transport === '1' || order.order_type_transport === '7'">
                                                <p class="mb-0">{{order.order_email}}</p>
                                            </template>
                                        </template>


                                        <template v-if="order.order_type_transport === '6'">
                                            <p class="mb-0">{{order.order_phone}}</p>
                                        </template>


                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="text-right">
                                        <img class="img-fluid"
                                             width="350"
                                             src="/images/logo-report.png" alt="logo">

                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <p bgcolor="#e6e6e6"
                                           class="bg-silver mb-3 text-dark text-left px-3 font-weight-bolder">
                                            <strong>IHRE DATEN:</strong>
                                        </p>
                                        <ul class="list-group border-0">
                                            <li class="list-group-item d-flex justify-content-between align-items-center border-0 py-1 font-weight-bolder">
                                                Datum:
                                                <span>{{orderMoreData.date}}</span>
                                            </li>
                                            <li class="list-group-item d-flex justify-content-between align-items-center border-0 py-1 font-weight-bolder">
                                                Bestellnummer:
                                                <span>{{order.order_tracking_number}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <br>
                            <br>

                            <h1 class="font-weight-bolder mb-4">Rechnung</h1>
                            <p class="mb-0">Lieber Kunde,</p>
                            <p>vielen Dank für Ihr Vertrauen in unsere Produkte. Wir stellen Ihnen hiermit folgende
                                Leistungen in Rechnung:</p>

                            <br>

                            <div class="table-responsive">
                                <table class="table">
                                    <thead class="bg-silver">
                                    <tr>
                                        <td class="font-weight-bolder"><strong>Pos. Art-Nr.</strong></td>
                                        <td class="font-weight-bolder"><strong>Beschreibung</strong></td>
                                        <td class="font-weight-bolder text-left"><strong>Verpackung</strong></td>
                                        <td class="font-weight-bolder text-left"><strong>Menge</strong></td>
                                        <td class="font-weight-bolder text-left"><strong>Preis</strong></td>
                                        <td class="font-weight-bolder text-right"><strong>Preis</strong></td>
                                    </tr>
                                    </thead>
                                    <template v-if="products.length">
                                        <tbody>
                                        <tr v-for="(product,index) in products" :key="index">
                                            <td>{{++index}}</td>
                                            <td v-html="product.product.product_title">2</td>
                                            <td class="text-left">{{product.priceItem.amount_title}}</td>
                                            <td class="text-left">{{product.priceItem.count}}</td>
                                            <td class="text-left" style="text-decoration: line-through">
                                                <template
                                                        v-if="(product.product.product_is_offer === 'yes' || product.product.product_is_offer === 'init') && product.priceItem.show_admin === 'no'">
                                                    <template v-if="product.product.product_is_gram_amount === 'yes'">
                                                        <template v-if="product.priceItem.type_price === 'gram_offer'">
                                                            <span>{{ product.priceItem.total_price_without_sell_item }} €</span>
                                                        </template>
                                                        <template v-else>
                                                            {{ product.priceItem.total_price_without_sell_item }} €
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        {{ product.priceItem.total_price_without_sell_item }} €
                                                    </template>

                                                </template>
                                            </td>
                                            <td class="text-right">
                                                <template
                                                        v-if="(product.product.product_is_offer === 'yes' || product.product.product_is_offer === 'init') &&  product.priceItem.show_admin === 'no'">
                                                    <template v-if="product.product.product_is_gram_amount === 'yes'">
                                                        <template v-if="product.priceItem.type_price === 'gram_offer'">
                                                            <span>{{ product.priceItem.total_price_sell_item }} €</span>
                                                        </template>
                                                        <template v-else>
                                                            {{ product.priceItem.total_price_sell_item }} €
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        {{ product.priceItem.total_price_sell_item }} €
                                                    </template>

                                                </template>

                                                <template v-else-if="product.product.product_is_gram_amount === 'yes' && product.priceItem.show_admin === 'no'">
                                                    <template v-if="product.priceItem.type_price === 'gram_offer'">
                                                        {{ product.priceItem.total_price_sell_item }} €
                                                    </template>
                                                    <template v-else>
                                                        {{ product.priceItem.total_price_item }} €
                                                    </template>
                                                </template>

                                                <template v-else>
                                                    {{ product.priceItem.total_price_item }} €
                                                </template>
                                            </td>
                                        </tr>

                                        <tr style="border-top: 2px solid #000">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="font-weight-bolder" style="color: #000">
                                                <strong>Zischensumme (ohne Rabatt):</strong>
                                            </td>
                                            <td class="text-right font-weight-bolder" style="color: #000">
                                                <strong>{{orderMoreData.price_subtotal}}
                                                    €</strong>
                                            </td>
                                        </tr>
                                        <tr v-if="order.order_price_coupon > 0">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                VIP-Kunde
                                                (-
                                                {{order.order_percent_coupon}}%
                                                Rabatt):
                                            </td>
                                            <td class="text-right">
                                                -
                                                {{orderMoreData.price_coupon}}
                                                €
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="text-danger">
                                                <span v-if="order.order_price_coupon > 0">
                                                    Extra Rabatte:
                                                </span>
                                                <span v-else>
                                                    Rabatt gesamt:
                                                </span>
                                            </td>
                                            <td class="text-right text-danger">
                                                - {{orderMoreData.price_discount}} €
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Zwischensumme ( mit Rabatt) :</td>
                                            <td class="text-right">{{orderMoreData.price_without_discount}} €</td>
                                        </tr>
                                        <tr v-if="order.order_price_difference > 0 && order.order_type_transport === '6'">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Differenz zum <br> Mindestbestellwert :</td>
                                            <td class="text-right">{{orderMoreData.price_difference_transport}} €</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>{{order.order_transport_title}}</td>
                                            <td class="text-right">{{order.order_transport_value}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>inkl. {{order.order_country_tax_amount}}% Mwst.:</td>
                                            <td class="text-right">{{orderMoreData.price_tax}} €</td>
                                        </tr>
                                        <tr style="border-bottom: 5px solid #000;border-top: 2px solid #000">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="font-weight-bolder" style="color: #000">
                                                <strong>Gesamtsumme:</strong>
                                            </td>
                                            <td class="text-right font-weight-bolder" style="color: #000">
                                                <strong>{{orderMoreData.price_total}} €</strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </template>

                                </table>

                            </div>


                            <br>
                            <br>

                            <p class="font-weight-bolder text-underline">
                                <strong>{{paymentType}}</strong>
                            </p>
                            <p>Bei Rückfragen stehen wir Ihnen wie gewohnt jederzeit gerne zur Verfügung.</p>
                            <br>
                            <p class="mb-0">Vielen Dank, dass Sie bei <strong>www.lordofhanf.com</strong> eingekauft
                                haben.</p>
                            <p>Beste Grüsse Ihr Lord of Hanf-Team</p>

                            <br>
                            <br>
                            <br>

                            <div class="row">
                                <div class="col-4">
                                    <p class="font-weight-bolder mb-0">Sitz des Unternehmens: </p>
                                    <p class="mb-0">Kramergass 3/15</p>
                                    <p class="mb-0">1010 Vienna</p>
                                    <p class="mb-0">Austria</p>
                                </div>
                                <div class="col-4">
                                    <p class="font-weight-bolder mb-0">Bankverbindung:</p>
                                  <template v-if="order.order_type_payment === 'purhcaseoninvoice'">
                                    <p class="mb-0">LORD OF HANF e.U.</p>
                                  </template>
                                  <template v-else>
                                    <p class="mb-0">Erste Bank</p>
                                  </template>

                                  <template v-if="order.order_type_payment === 'purhcaseoninvoice'">
                                    <p class="mb-0">IBAN: AT82 2011 1841 6058 6801</p>
                                  </template>
                                  <template v-else>
                                    <p class="mb-0">IBAN: AT12 2011 1841 6058 6800</p>
                                  </template>

                                    <p class="mb-0">BIC: GIBAATWWXXX</p>
                                </div>
                                <div class="col-4">
                                    <p class="font-weight-bolder mb-0">Kontoeigentümer:</p>
                                    <p class="mb-0">Lord of Hanf</p>
                                    <p class="mb-0">Firmenbuchnr.: FN 596010 k</p>
                                    <p class="mb-0">UID-Nr.: ATU79127268</p>
                                </div>
                            </div>
                        </div>
                    </b-card-body>

                </b-card>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import Navbar from "../Partials/Navbar";

    export default {
        name: "Print",
        components: {
            Navbar
        },
        data() {
            return {
                paymentType: "",
                order: {},
                orderMoreData: {},
                orderAddress: {},
                orderDeliveryAddress: {},
                products: []
            }
        },
        methods: {
            changePaymentType(payment) {
                this.paymentType = payment;
            },
            print() {
                this.$htmlToPaper('printMe');
            },
            getOrder() {
                if (this.$route.params.orderid && this.$route.params.orderid > 0) {
                    this.$Progress.start();
                    Http.get(Http.apiurl() + 'report/show/' + this.$route.params.orderid)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.order = response.data.data.order;
                                this.orderMoreData = response.data.data.order_moredata;
                                this.products = response.data.data.orders;
                                this.orderAddress = response.data.data.order_address;
                                this.orderDeliveryAddress = response.data.data.order_delivery_address;


                            } else {
                                Notification.error(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            }
        },
        created() {
            window.scrollTo(0, 0);
            this.getOrder();
        }
    }
</script>

<style scoped>
    .text-line {
        text-decoration: line-through;
    }

    table tr td {
        border-top: none;
    }

    .bg-silver {
        background-color: #e6e6e6;
    }

    #outlook a {
        padding: 0;
    }

    .ExternalClass {
        width: 100%;
    }

    .ExternalClass,
    .ExternalClass p,
    .ExternalClass span,
    .ExternalClass font,
    .ExternalClass td,
    .ExternalClass div {
        line-height: 100%;
    }

    .es-button {
        mso-style-priority: 100 !important;
        text-decoration: none !important;
    }

    a[x-apple-data-detectors] {
        color: inherit !important;
        text-decoration: none !important;
        font-size: inherit !important;
        font-family: inherit !important;
        font-weight: inherit !important;
        line-height: inherit !important;
    }

    .es-desk-hidden {
        display: none;
        float: left;
        overflow: hidden;
        width: 0;
        max-height: 0;
        line-height: 0;
        mso-hide: all;
    }
</style>